import { TagData } from 'search/components/Tag/types';

export enum TaxonomyCategory {
    SubjectArea,
    ContentType,
    Country,
    BackgroundKnowledge,
    VideoDuration,
    ContentSource,
    PopularTags,
    Role,
    Institution,
    Interests,
    AreaOfStudy,
    Location,
    Forum,
    Language,
    OrganizationType,
    Empty,
}

export interface TaxonomyData {
    id: string;
    category: TaxonomyCategory;
    tags: ReadonlyArray<TagData>;
}
